<template>
  <div>
    <div v-if="path === 'parks.roleSelection'">
      <Child />
    </div>
    <div class="main-layout" v-else>
      <div class="d-flex flex-column">
          <Banner :bgImage="`${baseURL}/storage/media/pcs/${theme}/banner.png`"/>
        <div id="other-content">
          <div id="left-column-section" class="overflow-auto">
            <LeftMenu />
            <!-- Replace LeftMenu with desired content/component(s) -->
          </div> 
          <div id="main-content">
            <Child />
          </div>
          <div id="right-column-section" class="limit-height">
            <Feed class="limit-height"/>
            <!-- Replace Feed with desired content/component(s) -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from './Subcomponents/Banner'
import LeftMenu from './Subcomponents/LeftMenu'
import Feed from '~/pages/modules/feed'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'BannerThreeColumnLayout',

  components: {
    Banner,
    LeftMenu,
    Feed
  },
  data () {
    return {
      theme: localStorage.getItem('theme')
    }
  },
  computed: {
    ...mapState('events', ['pageEvents', 'eventsLoaded']),
    path: function(){
      return this.$route.name
    },
    baseURL: function () {
      return process.env.MIX_BASE_URL
    },
  },
  watch : {
    path: function() {
      this.checkForPageWatch()
    },
    eventsLoaded: function(newValue, oldValue) {
      if (!oldValue && newValue) {
        this.checkForPageWatch()
      }
    }
  },
  methods: {
    ...mapActions('events', ['processEvent', 'clearPageWatch']),
    checkForPageWatch: function() {
      if (this.pageEvents.get(this.path)){
        this.processEvent({ eventId: this.pageEvents.get(this.path) })
        this.clearPageWatch({ page: this.path })
      }
    }
  },
  created: function() {
    localStorage.setItem('path', 'parks')
    // TODO: Change this to be dynamic instead of always routing to Seneca
  }
}
</script>
<style>
body {
  background-color: var(--background-gray);
}
</style>
<style scoped lang="scss">
.main-layout{
  background-color: var(--background-gray);
  overflow-y: auto;
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}

#other-content {
  flex: 1;
  display: grid;
  grid-template-areas:
  'left-column main-content right-column';
  grid-template-columns: 250px auto 250px;
}

#left-column-section {
  grid-area: left-column;
  height: 100%;
  overflow-y: auto;
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}

#main-content {
  grid-area: main-content;
  flex: 1;
}

#right-column-section {
  grid-area: right-column;
  background-color: rgba(225, 228, 230, 0.75);
}

.limit-height {
  max-height: 1250px;
  min-height: 75vh;
}
</style>
